import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle } = FiIcons;

const ResumeSkills = ({ skills }) => {
  return (
    <section className="mb-8">
      <h3 className="text-lg font-bold text-slate-900 uppercase tracking-wider border-b-2 border-slate-200 pb-2 mb-6">
        Skills & Competencies
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
        {skills.map((skillGroup, index) => (
          <div 
            key={index} 
            className="bg-slate-50 p-5 rounded-xl border border-slate-100 hover:border-blue-200 transition-colors skill-group"
          >
            <h4 className="font-bold text-blue-800 mb-4 text-[12px] uppercase tracking-widest border-b border-blue-100 pb-2">
              {skillGroup.category}
            </h4>
            <ul className="space-y-2">
              {skillGroup.items.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-[13.5px] text-slate-700">
                  <SafeIcon icon={FiCheckCircle} className="text-blue-500 mt-1 flex-shrink-0 text-sm" />
                  <span className="leading-tight font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ResumeSkills;